import React from "react";

import { FSCIDomainsCircle } from "src/components/fsci_domains_circle/fsci_domains_circle";
import { V1Domains } from "src/pages/reports/fsci/v1/types";

export type ReportDomainsCircleProps = {
    readonly inline?: boolean;
    readonly activeDomain?: V1Domains;
};

export const DomainsCircle = (props: ReportDomainsCircleProps): React.ReactElement => (
    <FSCIDomainsCircle {...props} legacyLearningDomain />
);
